import { Flex } from 'antd';
import Link from 'antd/es/typography/Link';

import getPlatformFromUrl from '@/lib/helpers/getPlatformFromUrl';
import Platforms from '@/pages/app/dashboard/creators/platforms';

export default function VideoPlatformLink({ item }: { item: any }) {
	const videoUrl = item?.data?.url || item?.metaData?.url;

	if (!videoUrl) {
		return null;
	}

	return (
		<Flex align="center" gap={8}>
			<Platforms platform={getPlatformFromUrl(videoUrl)?.id!} />
			<Link href={videoUrl} target="_blank">
				{videoUrl}
			</Link>
		</Flex>
	);
}
